/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_SyncInputs */



/**
* | output |
* | --- |
* | "Automatic Sync" |
*
* @param {Automatic_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_sync = /** @type {((inputs?: Automatic_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Synchronisierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая синхронизация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动同步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित सिंक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronização automática")
	return /** @type {LocalizedString} */ ("Automatic Sync")
});